import React from 'react';

const FlagIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M0.977997 23.0225V0.980469" stroke="#4B4B4B" />
      <path
        d="M0.979004 18.2405L4.069 17.2895C5.34928 16.8955 6.6989 16.779 8.02775 16.948C9.3566 17.117 10.6341 17.5675 11.775 18.2695C12.8883 18.9547 14.132 19.4005 15.4271 19.5787C16.7221 19.7569 18.04 19.6635 19.297 19.3045L22.223 18.4675C22.4535 18.4019 22.6562 18.2628 22.8006 18.0716C22.945 17.8803 23.023 17.6472 23.023 17.4075V4.79753C23.0227 4.62703 22.9828 4.45893 22.9067 4.30641C22.8305 4.15388 22.72 4.02107 22.5839 3.91839C22.4478 3.8157 22.2898 3.74594 22.1222 3.71456C21.9546 3.68318 21.782 3.69104 21.618 3.73753L19.297 4.40053C18.0401 4.75979 16.7221 4.8533 15.427 4.67511C14.1319 4.49691 12.8882 4.05091 11.775 3.36553C10.6339 2.66352 9.35625 2.21299 8.02724 2.044C6.69822 1.875 5.34845 1.99144 4.068 2.38553L0.979004 3.33653V18.2405Z"
        stroke="#4B4B4B"
      />
    </g>
  </svg>
);

export default FlagIcon;
